import { Component, OnInit } from '@angular/core';
import { URL_SPEED_TEST } from '@app/@core/constants/training.constants';
import { TranslateService } from '@ngx-translate/core';
import { RequirementsDataTable } from '../model/training.model';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss'],
})
export class TipsComponent implements OnInit {
  public requirements: RequirementsDataTable[];

  constructor(private translateService: TranslateService) {
    this.requirements = [
      {
        name: this.translateService.instant('tipsRequirements.computer'),
        min: this.translateService.instant('tipsRequirements.minComputer'),
        max: this.translateService.instant('tipsRequirements.maxComputer'),
      },
      {
        name: this.translateService.instant('tipsRequirements.memory'),
        min: this.translateService.instant('tipsRequirements.minMemory'),
        max: this.translateService.instant('tipsRequirements.maxMemory'),
      },
      {
        name: this.translateService.instant('tipsRequirements.screen'),
        min: this.translateService.instant('tipsRequirements.minScreen'),
        max: this.translateService.instant('tipsRequirements.maxScreen'),
      },
      {
        name: this.translateService.instant('tipsRequirements.conection'),
        min: this.translateService.instant('tipsRequirements.minConection'),
        max: this.translateService.instant('tipsRequirements.maxConection'),
      },
      {
        name: this.translateService.instant('tipsRequirements.systemOperative'),
        min: this.translateService.instant('tipsRequirements.minSystemOperative'),
        max: this.translateService.instant('tipsRequirements.maxSystemOperative'),
      },
      {
        name: this.translateService.instant('tipsRequirements.nav'),
        min: this.translateService.instant('tipsRequirements.minNav'),
        max: this.translateService.instant('tipsRequirements.maxNav'),
      },
      {
        name: this.translateService.instant('tipsRequirements.addSoftware'),
        min: this.translateService.instant('tipsRequirements.minAddSoftware'),
        max: this.translateService.instant('tipsRequirements.maxAddSoftware'),
      },
    ];
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe((event) => {
      this.requirements = [
        {
          name: this.translateService.instant('tipsRequirements.computer'),
          min: this.translateService.instant('tipsRequirements.minComputer'),
          max: this.translateService.instant('tipsRequirements.maxComputer'),
        },
        {
          name: this.translateService.instant('tipsRequirements.memory'),
          min: this.translateService.instant('tipsRequirements.minMemory'),
          max: this.translateService.instant('tipsRequirements.maxMemory'),
        },
        {
          name: this.translateService.instant('tipsRequirements.screen'),
          min: this.translateService.instant('tipsRequirements.minScreen'),
          max: this.translateService.instant('tipsRequirements.maxScreen'),
        },
        {
          name: this.translateService.instant('tipsRequirements.conection'),
          min: this.translateService.instant('tipsRequirements.minConection'),
          max: this.translateService.instant('tipsRequirements.maxConection'),
        },
        {
          name: this.translateService.instant('tipsRequirements.systemOperative'),
          min: this.translateService.instant('tipsRequirements.minSystemOperative'),
          max: this.translateService.instant('tipsRequirements.maxSystemOperative'),
        },
        {
          name: this.translateService.instant('tipsRequirements.nav'),
          min: this.translateService.instant('tipsRequirements.minNav'),
          max: this.translateService.instant('tipsRequirements.maxNav'),
        },
        {
          name: this.translateService.instant('tipsRequirements.addSoftware'),
          min: this.translateService.instant('tipsRequirements.minAddSoftware'),
          max: this.translateService.instant('tipsRequirements.maxAddSoftware'),
        },
      ];
    });
  }

  public onClickTestSpeed(): void {
    window.open(URL_SPEED_TEST);
  }
}
